import React from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import HomeIcon from "../../assets/icons-home-white.png";
import KitchenIcon from "../../assets/icons-kitchen-white.png";
import BathtubIcon from "../../assets/icons-bathroom-white.png";
import HouseIcon from "../../assets/icons-siding-white.png";
import RoofIcon from "../../assets/icons-roof-white.png";
import GarageIcon from "../../assets/icons-garage-white.png";
import FlooringIcon from "../../assets/icons-floor-white.png";

const serviceData = [
  {
    title: "COMPLETE HOME REMODELING",
    description:
      "Chicago region's honest, reliable and professional general contractor specializing in complete house remodel & renovation. Let's build something amazing together!",
    link: "#",
    icon: HomeIcon,
  },
  {
    title: "KITCHEN REMODEL",
    description:
      "Your kitchen serves many purposes. It’s a place for dining, entertaining, preparing meals, completing homework and paying bills. Let our remodeling experts create the perfect kitchen for your lifestyle.",
    link: "#",
    icon: KitchenIcon,
  },
  {
    title: "BATHROOM REMODEL",
    description:
      "From high-end luxury master suites to compact powder rooms, and everything in between, we’ve done it all. Providing functional & elegant bathrooms at a price you can afford.",
    link: "#",
    icon: BathtubIcon,
  },
  {
    title: "TILE INSTALLATION",
    description:
      "Enhance your home with beautiful and durable tile installation. Our experts ensure precision and quality, transforming your floors, walls, and backsplashes with a wide variety of tile options.",
    link: "#",
    icon: HouseIcon,
  },
  {
    title: "FLOOR INSTALLATION",
    description:
      "The right flooring selection is critical to your home. It not only enhances the visual appeal of your property but can add monetary value as well.",
    link: "#",
    icon: FlooringIcon,
  },
  {
    title: "PLUMBING",
    description:
      "Our skilled plumbers provide comprehensive plumbing services, from leak repairs to complete plumbing installations. Trust us to keep your home's water systems running smoothly and efficiently.",
    link: "#",
    icon: RoofIcon,
  },
  {
    title: "GARAGE REMODEL",
    description:
      "Complete garage renovation services including: Epoxy floors, custom doors, drywall & texture, insulation, cabinets and custom storage.",
    link: "#",
    icon: GarageIcon,
  },
  {
    title: "ELECTRICITY",
    description:
      "Ensure your home is safely wired with our expert electrical services. From new installations to repairs and upgrades, we provide reliable electrical solutions for all your needs.",
    link: "#",
    icon: HomeIcon,
  },
  {
    title: "HANDYMAN SERVICES",
    description:
      "From hanging your TV to drywall repair and full kitchen remodels, we've got you covered! Enjoy great customer service and integrity on every job with our versatile handyman services.",
    link: "#",
    icon: KitchenIcon,
  },
];

const Services = () => {
  const cardStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: 3,
    height: "100%",
    backgroundColor: "#007aff",
    color: "white",
  };

  return (
    <Box id="services" sx={{ flexGrow: 1, padding: 4 }}>
      <Grid container spacing={4} marginBottom={5}>
        {serviceData.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} marginBottom={5}>
            <Card sx={cardStyle}>
              <img
                src={service.icon}
                alt={service.title}
                style={{ width: 120, height: 120, marginLeft: "20px" }}
              />
              <CardContent>
                <Typography
                  sx={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontSize: "18px",
                  }}
                  gutterBottom
                >
                  {service.title}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    textTransform: "none",
                    fontSize: "14px",
                  }}
                  paragraph
                >
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services;
